import {MusicService} from "../../../../services/MusicService";
import React from "react";
import {useActions} from "../../../../hooks/useActions";
import {useTypedSelector} from "../../../../hooks/useTypedSelector";
import {isMobile} from "react-device-detect";

function ComicsExitButton({cpuStory, closeComics}: any){

    const {setCpuStory, startGame, setRoute, setTutorial} = useActions();
    const {isLoading, tutorial} = useTypedSelector(state => state.auth);

    let storyClass = 'storySkipButton';

    if(isMobile){
        storyClass = 'storySkipButton storySkipButtonMobile';
    }

    return (<div
        className={storyClass + ' defaultButtonAnimation_6'}
        onClick={async () => {
            if (isLoading) {
                return;
            }

            if (closeComics !== null) {
                closeComics();
                return;
            }

            if (cpuStory.action === 'before') {
                await startGame(cpuStory.cpuId);
                await new Promise(r => setTimeout(r, 100));

                setRoute('game');

                MusicService.stopTutorial();
                MusicService.stopMenu();
                MusicService.playBattleMusic();
            } else {
                if (tutorial.isActive === false && tutorial.step === 'ArenaStart200') {
                    setTutorial({
                        ...tutorial,
                        isActive: true,
                    });
                    setRoute('home');
                    cpuStory.action = null;
                    setCpuStory(cpuStory);
                    return;
                }

                setRoute('boss');
                if (tutorial.isActive === false && tutorial.step === 'BattleFinish80') {
                    tutorial.isActive = true;
                    tutorial.step = 'BossWindowSecond82';
                    setTutorial(tutorial);
                }
                if (tutorial.isActive === false && tutorial.step === 'BossWindowSecond82') {
                    tutorial.isActive = true;
                    tutorial.step = 'BossWindowSecond84';
                    setTutorial(tutorial);
                }
                if (tutorial.isActive === false && tutorial.step === 'BossWindowSecond84') {
                    tutorial.isActive = true;
                    tutorial.step = 'MenuResearch90';
                    setTutorial(tutorial);
                }
            }

            cpuStory.action = null;
            setCpuStory(cpuStory);
        }}
    >
</div>)
}

export default ComicsExitButton;
